import * as React from 'react';
import ExpandMore from '@mui/icons-material/ExpandMore';
import {
  Collapse,
  List,
  ListItemIcon,
  MenuItem,
  Tooltip,
  Typography,
} from '@mui/material';
import { useTranslate } from 'react-admin';

interface Props {
  dense: boolean;
  handleToggle: () => void;
  icon: React.ReactElement;
  isOpen: boolean;
  name: string;
  sidebarIsOpen: boolean;
  children?: React.ReactNode;
}

const SubMenu: React.FC<Props> = ({
  handleToggle,
  sidebarIsOpen,
  isOpen,
  name,
  icon,
  children,
  dense,
}) => {
  const translate = useTranslate();

  const header = (
    <MenuItem dense={dense} onClick={handleToggle}>
      <ListItemIcon sx={{ mr: 0.5 }}>
        {isOpen ? <ExpandMore /> : icon}
      </ListItemIcon>
      <Typography variant="inherit" color="textSecondary">
        {translate(name)}
      </Typography>
    </MenuItem>
  );

  return (
    <React.Fragment>
      {sidebarIsOpen || isOpen ? (
        header
      ) : (
        <Tooltip title={translate(name)} placement="right">
          {header}
        </Tooltip>
      )}
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List
          dense={dense}
          component="div"
          disablePadding
          sx={{
            ml: sidebarIsOpen ? 4 : 0,
            transition: 'margin-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
          }}
        >
          {children}
        </List>
      </Collapse>
    </React.Fragment>
  );
};

export default SubMenu;
